import React, { useEffect, useState } from "react";
import { Grid, Table, TableBody, TableRow } from "@mui/material";
import { injectIntl } from "react-intl";
import {
  commaSeparateFormat,
  dateFormat,
  getPropertyTypeGroup,
  isMobileWidth,
} from "../../resources/utils";
import {
  StyleHeading,
  StyleTableHead,
  StyleTableHeadCell,
  StyleTableRow,
  StyleTableCell,
  StyleTypography,
} from "../../assets/js/Theme";
import { getMarketDataRecords } from "../../crud/chart.crud";
import {
  APARTMENT_GROUP_ID,
  DEVICE_WIDTH,
  IS_MOBILE_WIDTH,
} from "../../resources/Constants";

const SoldProperties = (props) => {
  const { intl, overallResults, reportHash } = props;
  // const reportId = overallResults?.reportId || "";
  const [marketRecords, setMarketRecords] = useState([]);
  const [subjectLocation, setSubjectLocation] = useState("");
  // const TIME_PERIOD = 6;

  const _getMarketDataRecords = async () => {
    try {
      const queryParams = {
        unitSizeSqft: overallResults?.unitSizeSqft || "",
        plotSizeSqft: overallResults?.plotSizeSqft || "",
        propertyTypeId: overallResults?.propertyTypeId || "",
        locationId: overallResults?.locationId || "",
        bedrooms: overallResults?.bedrooms || "",
        bathrooms: overallResults?.bathrooms || "",
        // reportId
        // timePeriod: TIME_PERIOD,
        reportHash,
      };
      const result = await getMarketDataRecords(queryParams);
      const { status, data, location } = result.data;
      setSubjectLocation(location);
      if (status === 1) {
        setMarketRecords(data);
      } else {
        console.log("data are not populated");
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    _getMarketDataRecords();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid container className="recent--sold--wrapper">
      <Grid item xs={12} className="section--heading--wrapper">
        <hr />
        <StyleHeading color="secondary" className="heading--text" variant="h2">
          {intl.formatMessage({
            id: "SOLD.HEADING.SOLD_PROPERTIES",
          })}
        </StyleHeading>
        <hr />
      </Grid>

      <Grid item xs={12}>
        <StyleTypography color="primary" gutterBottom>
          {intl.formatMessage(
            {
              id: "SOLD.HEADING.RECENT_SOLD_PROPERTIES",
            },
            {
              breakLine: <span className="break--line" />,
              location: subjectLocation,
            }
          )}
        </StyleTypography>
      </Grid>
      <Grid
        item
        xs={12}
        className="recent--sold--table--wrapper"
        style={DEVICE_WIDTH <= IS_MOBILE_WIDTH ? isMobileWidth : null}
      >
        <Table>
          <StyleTableHead>
            <TableRow>
              <StyleTableHeadCell align="center" width="50">
                {intl.formatMessage(
                  { id: "SOLD.LABEL.TRANSACTION_DATE" },
                  { break: <br /> }
                )}
              </StyleTableHeadCell>
              <StyleTableHeadCell width="250">
                {intl.formatMessage(
                  { id: "GENERAL.PROPERTY_ADDRESS" },
                  { break: "" }
                )}
              </StyleTableHeadCell>
              <StyleTableHeadCell align="center" width="50">
                {intl.formatMessage(
                  { id: "GENERAL.PROPERTY_TYPE" },
                  { break: <br /> }
                )}
              </StyleTableHeadCell>
              <StyleTableHeadCell align="center" width="80">
                {intl.formatMessage(
                  { id: "GENERAL.NO_OF_BEDROOM" },
                  { break: <br /> }
                )}
              </StyleTableHeadCell>
              <StyleTableHeadCell align="center" width="50">
                {intl.formatMessage(
                  { id: "SOLD.LABEL.TRANSACTION_PRICE" },
                  { break: <br /> }
                )}
              </StyleTableHeadCell>
              <StyleTableHeadCell align="center" width="110">
                {`${intl.formatMessage({
                  id: "GENERAL.PRICE_PER_SQ_FT",
                })}`}
                <br />(
                {intl.formatMessage({
                  id: "GENERAL.AED",
                })}
                )
              </StyleTableHeadCell>
              <StyleTableHeadCell align="center" width="70">
                {`${intl.formatMessage({
                  id: "GENERAL.UNIT_SIZE",
                })}`}
                <br />
                {intl.formatMessage({
                  id: "GENERAL.SQ_FT",
                })}
              </StyleTableHeadCell>
              {getPropertyTypeGroup(overallResults?.propertyTypeId) !==
              APARTMENT_GROUP_ID ? (
                <StyleTableHeadCell align="center" width="70">
                  {`${intl.formatMessage({
                    id: "GENERAL.PLOT_SIZE",
                  })}`}
                  <br />
                  {intl.formatMessage({
                    id: "GENERAL.SQ_FT",
                  })}
                </StyleTableHeadCell>
              ) : null}
            </TableRow>
          </StyleTableHead>
          <TableBody>
            {marketRecords.map((row) => (
              <StyleTableRow key={row.id}>
                <StyleTableCell align="center">
                  {dateFormat(row.evidence_date)}
                </StyleTableCell>
                <StyleTableCell>{row?.property_address || ""}</StyleTableCell>
                <StyleTableCell align="center">
                  {row.property_type_name}
                </StyleTableCell>
                <StyleTableCell align="center">{row.no_beds}</StyleTableCell>
                <StyleTableCell align="center">
                  {commaSeparateFormat(row.total_sales_price)}
                </StyleTableCell>
                <StyleTableCell align="center">
                  {commaSeparateFormat(row.sales_price_sqft_unit)}
                </StyleTableCell>
                <StyleTableCell align="center">
                  {commaSeparateFormat(row.built_up_area_sqft)}
                </StyleTableCell>
                {getPropertyTypeGroup(overallResults?.propertyTypeId) !==
                APARTMENT_GROUP_ID ? (
                  <StyleTableCell align="center">
                    {commaSeparateFormat(row.plot_size_sqft)}
                  </StyleTableCell>
                ) : null}
              </StyleTableRow>
            ))}
          </TableBody>
        </Table>
      </Grid>
    </Grid>
  );
};

export default injectIntl(SoldProperties);
